import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { NoteCategorySchema } from './note-category.schema';
import { NoteGeometrySchema } from './note-geometry.schema';
import { NoteTargetsSchema } from './note-targets.schema';
/**
 * Draft-side sticky note (`processdraftnotes`). Staged in the draft like steps:
 * created/edited/deleted with undo, and promoted to a live `ProcessNote` on
 * publish (full replace). Notes are co-processed by no flow logic — no edges,
 * inputs, successors, suggestions, invites or validation — so they live in
 * their own collection rather than as a step `nodeKind` (see ADR 0008).
 */ export const ProcessDraftNoteSchema = z.object({
    _id: ObjectIdSchema,
    draftId: ObjectIdSchema,
    processId: ObjectIdSchema,
    text: z.string(),
    category: NoteCategorySchema,
    geometry: NoteGeometrySchema,
    targets: NoteTargetsSchema,
    createdBy: ObjectIdSchema,
    updatedAt: z.date()
});

//# sourceMappingURL=process-draft-note.schema.js.map